import $ from 'jquery'

export default () => {
    let status = 0
    const $fakeSubmit = $('.js-sign-up-fake-form-submit')
    const $fakeInputDuplicationDestination = $('.js-sign-up-input-duplicate-destination')
    const $checkboxes = $('.js-sign-up-checkbox')
    const $checkboxesAllControl = $('.js-sign-up-checkbox-all')
    const $submitButton = $('.js-sign-up-submit')

    $checkboxes.click(function() {
        const $this = $(this)

        setStatus($this)
        validateStatus()
        enableCheckAll()
    })

    $checkboxesAllControl.click(function() {
        status = $checkboxes.length
        checkAll()
        enableSubmit()
    })

    $fakeSubmit.click(function() {
        const $fakeInput = $(this).parents('.js-sign-up-fake-form-context').find('.js-sign-up-fake-form-email')
        if ($fakeInput.is(':valid')) {
            const value = $fakeInput.val()
            
            $fakeInputDuplicationDestination.val(value)
        }
    })

    const setStatus = function($el) {
        status = $el.is(':checked') ? ++status : --status
    }

    const validateStatus = function() {
        status > 0 ? $submitButton.prop('disabled', false) : $submitButton.prop('disabled', true)
    }

    const checkAll = function() {
        $checkboxes.prop('checked', true)
        disableCheckAll()
    }

    const enableSubmit = function() {
        $submitButton.prop('disabled', false)
    }

    const enableCheckAll = function() {
        $checkboxesAllControl.prop('disabled', false)
    }

    const disableCheckAll = function() {
        $checkboxesAllControl.prop('disabled', true)
    }
}